import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { WhitelistReadDto } from '../_models/whitelistReadDto';
import { InfiniteResult } from '../_models/body';

@Injectable({
  providedIn: 'root'
})
export class WallPostService {
  httpOptions: any = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  constructor(private http: HttpClient) { }

  getAll(params) {
    return this.http.get<InfiniteResult>(`${environment.apiEndpoint}api/WallPost/Query`, {
      params: params
    });
  }

}
